module.exports = __webpack_public_path__ + "img/onColor.48864083.svg";